import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Partition_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_PARTITION_ID:         {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Partition Id',  columnResourceName: 'colId',            alignment: HorizAlignment.Left},  domainOptions: {} },
    PARTITION_ID:            {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Partition Id',     columnResourceName: 'colId',            alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    PARTITION_NAME:          {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Partition Name',       columnResourceName: 'colName',  alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const PartitionSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_PARTITION_ID',
        id_ui: 'PARTITION_ID',
        name:  'PARTITION_NAME'

    },

    searchProviderFields: vUI_Partition_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Partition_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const PartitionSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "PartitionSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'PARTITION_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'PARTITION_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'PARTITION_ID', 'PARTITION_NAME', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: PartitionSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const PartitionSearch: ISearch = {
    searchName: "Find Partition",
    renderOptions: {ui5ResourceId: "PartitionSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [PartitionSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("PartitionBO", "Partition", PartitionSearch, "Partition Search")

export {PartitionSearch}